import { TimelineMax } from 'gsap/TweenMax'

function fadeAnimations() {
    const tl = new TimelineMax()
  
    tl.delay(1)
      .fromTo('.o-layout__head-overlay .o-layout__head-overlay--dark', 1.2, {opacity: 1}, {opacity: 0}, 0)
      .fromTo('.o-layout__head-overlay .o-layout__head-overlay--upper', 1.2, {y: 0}, {y: -140}, 2.5)
      .fromTo('.o-layout__head-overlay .o-layout__head-overlay--lower', 1.2, {y: 0}, {y: 140}, 2.5)  
      .fromTo( '.c-sticky-20', 1.2, {opacity: 0, x: -50}, {opacity: 1, x: 0}, 2.5 )
      .fromTo('.c-language-switcher', 1.2, {opacity: 0, y: -50}, {opacity: 1, y: 0}, 2.5 )
      .fromTo('.c-sticky-footer__logo', 1.2, {opacity: 0, y: 50}, {opacity: 1, y: 0}, 2.5 )
      .fromTo('.c-button--contact', 1.2, {opacity: 0, y: 50}, {opacity: 1, y: 0}, 2.5 )
      .fromTo('.c-button[data-toggle="menu"]', 1.2, {opacity: 0, x: 50}, {opacity: 1, x: 0}, 2.5 )
  
    return tl
  } 

export default fadeAnimations
